import { QuoteFilterIcon } from "~/features/Quotes/constants/quoteTableIcons";
import {
  CreatedByFilterObj,
  getFacilityFilterObj,
  QUOTE_AMOUNT,
  QUOTE_DATE,
  QUOTE_STATUS,
  QUOTE_VALID_UNTIL,
  QUOTE_WORK_ORDER,
} from "./filters";

export const QuoteStatusFilterObj = {
  id: QUOTE_STATUS,
  name: "Status",
  icon: QuoteFilterIcon.status,
};

export const QuoteDateFilterObj = {
  id: QUOTE_DATE,
  name: "Created at",
  icon: QuoteFilterIcon.calendar,
};

export const QuoteAmountFilterObj = {
  id: QUOTE_AMOUNT,
  name: "Amount",
  icon: QuoteFilterIcon.amount,
};

export const QuoteValidUntilFilterObj = {
  id: QUOTE_VALID_UNTIL,
  name: "Valid Until",
  icon: QuoteFilterIcon.calendar,
};

/** Legacy / persisted filter — not in default Add Filter list. */
export const QuoteWorkOrderFilterObj = {
  id: QUOTE_WORK_ORDER,
  name: "Work Order",
  icon: QuoteFilterIcon.workOrder,
};

export const QuoteCompanyFilterObj = {
  ...getFacilityFilterObj(),
  icon: QuoteFilterIcon.company,
};

export const QuoteCreatedByFilterObj = {
  ...CreatedByFilterObj,
  icon: QuoteFilterIcon.createdBy,
};

/** Required filters for quotes list (order preserved in Add Filter menu). */
export const financeQuotesDefaultFilters = [
  QuoteStatusFilterObj,
  QuoteCompanyFilterObj,
  QuoteDateFilterObj,
  QuoteAmountFilterObj,
  QuoteValidUntilFilterObj,
  QuoteCreatedByFilterObj,
];
